import { BaseHelmet, EntityDetailsWrapper, StatusTab, VariablesTab } from 'components';
import { LogsTab } from 'components/Package/LogsTab';
import type { EntityTab } from 'contracts/interfaces';
import type { FC } from 'react';

interface PackageProps {
  isEditable: boolean;
}
const Package: FC<PackageProps> = ({ isEditable }) => {
  const tabs: EntityTab[] = [
    { label: 'Status', isActive: true, content: <StatusTab isEditable={isEditable} /> },
    { label: 'Variables', content: <VariablesTab locked={isEditable === false} /> },
    { label: 'Logs', content: <LogsTab /> }
  ];

  return (
    <>
      <BaseHelmet page="Package" />
      <EntityDetailsWrapper tabs={tabs} />
    </>
  );
};

export default Package;
